const buttonMediumHeight = 40;
const buttonLargeHeight = 60;

export const toggleText = ({ isRound }) => ({
  background: "background",
  padding: "4px",
  borderRadius: isRound ? "1000px" : "6px",
  border: "1px solid",
  borderColor: "grey5",
});

export const container = ({ size }) => ({
  boxSizing: "border-box",
  position: "relative",
  height: size === "large" ? buttonLargeHeight : buttonMediumHeight,
  display: "flex",
  flexDirection: "row",

  label: {
    outline: "none",
    background: "transparent",
    border: "none",
    position: "relative",
    zIndex: "2",
    lineHeight: "1",
    fontSize: "18px",
    fontWeight: "body",
    textAlign: "center",
    letterSpacing: "1px",
    cursor: "pointer",
    color: "grey5",
    textTransform: "uppercase",
    height: size === "large" ? buttonLargeHeight : buttonMediumHeight,
    width: "100%",
    margin: "0",
    padding: "0",

    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",

    input: {
      display: "none",
    },

    "input:checked + div": {
      transition: "color .1s ease-out",
      color: "white",
    },
  },
});

export const selection = ({ optionsCount, isRound }) => {
  return {
    display: "block",
    position: "absolute",
    zIndex: "1",
    top: 0,
    bottom: 0,
    left: 0,
    width: `${100 / optionsCount}%`,
    backgroundColor: "black",
    borderRadius: isRound ? "1000px" : "2px",
    transition: "left 0.2s ease",
  };
};
